import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { getCounts } from "@/lib/admin-api";

export const Route = createFileRoute("/admin/")({
  component: AdminDashboard,
});

function AdminDashboard() {
  const [counts, setCounts] = useState({ pendingPhotoApplications: 0, pendingVisagistApplications: 0, newBriefs: 0, approvedPhotographers: 0, approvedVisagists: 0, pendingCommunity: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCounts().then((c) => { setCounts(c); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const cards = [
    { label: "Offene Fotografen-Bewerbungen", value: counts.pendingPhotoApplications, to: "/admin/applications" as const },
    { label: "Offene Visagisten-Bewerbungen", value: counts.pendingVisagistApplications, to: "/admin/applications" as const },
    { label: "Neue Briefings", value: counts.newBriefs, to: "/admin/briefs" as const },
    { label: "Approved Fotografen", value: counts.approvedPhotographers, to: "/admin/photographers" as const },
    { label: "Approved Visagisten", value: counts.approvedVisagists, to: "/admin/visagists" as const },
    { label: "Offene Community-Einreichungen", value: counts.pendingCommunity, to: "/admin/community" as const },
  ];

  return (
    <div>
      <div className="eyebrow text-muted-foreground">Übersicht</div>
      <h1 className="serif text-4xl md:text-5xl mt-3">Redaktions-Dashboard</h1>
      <div className="grid sm:grid-cols-3 gap-4 mt-10">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="border border-border p-6 hover:bg-muted/30 transition-colors">
            <div className="eyebrow text-muted-foreground">{c.label}</div>
            <div className="serif text-5xl mt-4">{loading ? "" : c.value}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}